module.exports = __webpack_public_path__ + "img/logo-js.5df7d115.png";